<div class="confirm-form-container">
  <div class="description">
    <p class="text">
      {{ 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.CONFIRM_MESSAGE' | transloco }}
    </p>
    <div class="alert-info">
      <div>
        <span>{{ 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ARRIVAL_LABEL' | transloco }}</span>
        <p>{{alert?.arrival_name}}</p>
      </div>
      <div>
        <span>{{ 'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.SCALES' | transloco }}</span>
        <p>{{'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.'  + connectionType | transloco}}</p>
      </div>
      <ng-container *ngIf="withFlexDatesInAlert; else simpleDates">
        <ng-container *ngTemplateOutlet="rangeDates"></ng-container>
      </ng-container>
      <div class="last">
        <span>{{ 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.PRICE_PLACEHOLDER' | transloco }}</span>
        <p>{{alertMaxPrice | currencyFormat: alert?.currency}}</p>
      </div>
    </div>
  </div>
  <div class="actions">
    <div class="button-container">
      <app-ds-button
        [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.CANCEL' | transloco }"
        (clickEvent)="toggleConfirmForm()">
      </app-ds-button>
    </div>
    <div class="remove-alert">
      <app-ds-button
        [type]="removeButtonType"
        [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.DELETE.CONFIRM_REMOVE' | transloco }"
        (clickEvent)="removeAlert()">
      </app-ds-button>
    </div>
  </div>
</div>


<ng-template #simpleDates>
  <div>
    <span>{{'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.FLIGHT_DEPARTURE' | transloco}}</span>
    <p>{{alert?.outbound_min | date: 'dd MMM' | dateFormat | capitalize}}</p>
  </div>
  <div *ngIf="!isOneWay">
    <span>{{'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.FLIGHT_RETURN' | transloco}}</span>
    <p>{{alert?.inbound_max | date: 'dd MMM' | dateFormat | capitalize}}</p>
  </div>
</ng-template>

<ng-template #rangeDates>
  <div>
    <span>{{'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.FLIGHT_DEPARTURE_BETWEN' | transloco}}</span>
    <p>{{alert?.outbound_min | date: 'dd MMM' | dateFormat | capitalize}} - {{alert?.outbound_max | date: 'dd MMM' | dateFormat | capitalize}}</p>
  </div>
  <div *ngIf="!isOneWay">
    <span>{{'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.FLIGHT_RETURN_BETWEN' | transloco}}</span>
    <p>{{alert?.inbound_min | date: 'dd MMM' | dateFormat | capitalize}} - {{alert?.inbound_max | date: 'dd MMM' | dateFormat | capitalize}}</p>
  </div>
</ng-template>